import Vue from 'vue'
import Router from 'vue-router'
import useReporter from "@/utils/reporter";
import store from "@/store/store";
import oInitData from "@/libsV2/request";
import statistic from "@/js/member/statistics";
import storage from "@/libsV2/storage";
import common from "@/libsV2/common";
import defalutData from "@/libsV2/defaultData";
import cookie from "@/libsV2/cookie";

Vue.use(Router)

const SALES = r => require.ensure([], () => r(require('@/page/other/poster/sales')), 'sales');
const XCX_BUSINESS = r => require.ensure([], () => r(require('@/page/other/xcx/business/info')), 'business');
const XCX_CASE_INFO = r => require.ensure([], () => r(require('@/page/other/xcx/case/info')), 'case');
const SALES_SHARE = r => require.ensure([], () => r(require('@/page/other/poster/share')), 'sharesales');
const LOOKIMG = r => require.ensure([], () => r(require('@/page/other/poster/lookimg')), 'lookimg');
const POSLIST = r => require.ensure([], () => r(require('@/page/other/poster/lists')), 'lists');
// cms
const RELEASE = r => require.ensure([], () => r(require('@/page/cms/release')), 'release');
const COLUMN = r => require.ensure([], () => r(require('@/page/cms/column')), 'column');
const PREVIEW = r => require.ensure([], () => r(require('@/page/cms/preview')), 'preview');

// 案例详情
const DETAIL = r => require.ensure([], () => r(require('@/page/case/details/olddetail')), 'detail');
const OLDDETAIL = r => require.ensure([], () => r(require('@/page/case/details/olddetailshare')), 'olddetail');
const OLDDETAILIMG = r => require.ensure([], () => r(require('@/page/case/details/olddetailimg')), 'olddetailimg');
//优选案例
const CASEINDEX = r => require.ensure([], () => r(require('@/page/case/index')), 'caseindex');
const CASEDETAILS = r => require.ensure([], () => r(require('@/page/case/details/details')), 'casedetails');
const CASEDETAILS_V2 = r => require.ensure([], () => r(require('@/page/case/map/v2/details')), 'casedetailsv2');
// 致总裁信
const SPECIAL = r => require.ensure([], () => r(require('@/page/case/map/v2/special')), 'specialIndex');
const SPECIAL_INFO = r => require.ensure([], () => r(require('@/page/case/map/v2/specialinfo')), 'specialinfo');
// 门店列表
const CASEDETAILSLIST_V2 = r => require.ensure([], () => r(require('@/page/case/map/v2/store')), 'casestorelistv2');

const CASEDETAILSSHARE = r => require.ensure([], () => r(require('@/page/case/details/share')), 'casedetailsShare');
const CASEDETAILSSHARELINK = r => require.ensure([], () => r(require('@/page/case/details/sharelink')), 'casedetailsSharelink');
const CASE_MAP = r => require.ensure([], () => r(require('@/page/case/map/index')), 'caseMap');
const CASE_MAP_v1 = r => require.ensure([], () => r(require('@/page/case/map/v1/index')), 'caseMapCopy');
const CASE_MAP_v2 = r => require.ensure([], () => r(require('@/page/case/map/v2/index')), 'caseMapCopyV2');
const CASEDRAFT = r => require.ensure([], () => r(require('@/page/case/draft/index')), 'casedraft');
const CASE_LIST_v1 = (r) => require.ensure([], () => r(require('@/page/case/map/v2/lists')), 'caseV1');

// 水系统报告长页
const SYSTEMREPORT = r => require.ensure([], () => r(require('@/page/report/index'), 'report'));


// 艾暖通
const ANT_MAP = r => require.ensure([], () => r(require('@/page/project/antMap/index'), 'antMap'));
const ANT_DETAILS = r => require.ensure([], () => r(require('@/page/project/antdetails/index'), 'antDetails'));
const CANVAS_DETAILS = r => require.ensure([], () => r(require('@/page/project/canvasimg/index'), 'canvasimg'));
const ANT_SHARE = r => require.ensure([], () => r(require('@/page/project/antshare/index'), 'antshare'));
const ANT_INFO = r => require.ensure([], () => r(require('@/page/proposal/antInfo/index'), 'antInfo'));
const ANT_PROJECT = r => require.ensure([], () => r(require('@/page/proposal/antInfo/project'), 'antProject'));
const ANT_SUBMIT = r => require.ensure([], () => r(require('@/page/proposal/antInfo/submit'), 'antInfoSubmit'));
const ANTERROR = r => require.ensure([], () => r(require('@/page/proposal/error/index'), 'antError'));

// 艾暖通v2
const ANTEND = r => require.ensure([], () => r(require('@/page/proposal/end/index'), 'antend'));
const ANTEND_V2 = r => require.ensure([], () => r(require('@/page/proposalv2/end/index'), 'antend'));
const ANTSELECTION = r => require.ensure([], () => r(require('@/page/proposal/selection/index'), 'antSelection'));
const ANTSELECTION_V2 = r => require.ensure([], () => r(require('@/page/proposalv2/selection/index'), 'antSelection'));
const ANTPARAMETER = r => require.ensure([], () => r(require('@/page/proposal/parameter/index'), 'antParameter'));
const ANTPARAMETER_V2 = r => require.ensure([], () => r(require('@/page/proposalv2/parameter/index'), 'antParameter'));
const ANTOFFTER = r => require.ensure([], () => r(require('@/page/proposal/offter/index'), 'antOffter'));
const ANTOFFTER_V2 = r => require.ensure([], () => r(require('@/page/proposalv2/offter/index'), 'antOffter'));
const ANTSCHEME = r => require.ensure([], () => r(require('@/page/proposal/scheme/index'), 'antScheme'));
const ANTSCHEME_V2 = r => require.ensure([], () => r(require('@/page/proposalv2/scheme/index'), 'antScheme'));
const ANTEDITSCHEME = r => require.ensure([], () => r(require('@/page/proposal/editscheme/index'), 'antEditScheme'));
const BASIC_INFO = r => require.ensure([], () => r(require('@/page/proposal/basicinfo/index'), 'basicinfo'));
const BASIC_INFO_V2 = r => require.ensure([], () => r(require('@/page/proposalv2/basicinfo/index'), 'basicinfo'));
const SHOPP_DETAILS = r => require.ensure([], () => r(require('@/page/goods/details/details'), 'shoppdetails'));
const SHOPP_LIST = r => require.ensure([], () => r(require('@/page/goods/lists/list'), 'shopplist'));
const SHOPP_CONTENT = r => require.ensure([], () => r(require('@/page/goods/content/index'), 'shoppcontent'));
const CONTENT_DETAIL = r => require.ensure([], () => r(require('@/page/goods/content/details/index'), 'contentdetails'));
const PDF = r => require.ensure([], () => r(require('@/page/proposal/pdf/pdfindex'), 'pdfindex'));
const PDFIFRAME = r => require.ensure([], () => r(require('@/page/proposal/pdf/sharepdf'), 'sharepdf'));
// 案例报表
const ANALYSIS_REPORT = r => require.ensure([], () => r(require('@/page/user/analysis/report'), 'analysis_report'));
const ANALYSIS_DETAIL = r => require.ensure([], () => r(require('@/page/user/analysis/detail'), 'analysis_detail'));
const ANALYSIS_REPORT_V2 = r => require.ensure([], () => r(require('@/page/user/analysisV2/report'), 'analysis_report_v2'));
const ANALYSIS_DETAIL_V2 = r => require.ensure([], () => r(require('@/page/user/analysisV2/detail'), 'analysis_detail_v2'));

// 业绩在线
const PERFORMACE_ONLINE = r => require.ensure([], () => r(require('@/page/hvac/performance/online/index'), 'performance_online'));
//用户画像
const PERFORMACE_USER_PORTRAIT = r => require.ensure([], () => r(require('@/page/hvac/performance/user/portrait'), 'performance_user_portrait'));
//客户上线
const PERFORMACE_USER_CUSTOMER = r => require.ensure([], () => r(require('@/page/hvac/performance/user/customer'), 'performance_user_customer'));
//用户旅程
const PERFORMACE_USER_JOURNEY = r => require.ensure([], () => r(require('@/page/hvac/performance/user/journey'), 'performance_user_journey'));
//项目清单
const PERFORMACE_USER_DETAILED = r => require.ensure([], () => r(require('@/page/hvac/performance/user/detailed'), 'performance_user_detailed'));
//业绩在线
const PERFORMACE_USER_MODEL = r => require.ensure([], () => r(require('@/page/hvac/performance/user/usermodel'), 'performance_user_usermodel'));
//业绩分析
const PERFORMACE_RESULT_INDEX = r => require.ensure([], () => r(require('@/page/hvac/performance/result/index'), 'performance_result_index'));
const PERFORMACE_RESULT_ANALYSIS = r => require.ensure([], () => r(require('@/page/hvac/performance/result/analysis'), 'performance_result_analysis'));
const PERFORMACE_RESULT_DOCUMENTARY = r => require.ensure([], () => r(require('@/page/hvac/performance/result/documentary'), 'performance_result_documentary'));
const PERFORMACE_RESULT_CHANNEL = r => require.ensure([], () => r(require('@/page//hvac/performance/result/channel'), 'performance_result_channel'));
const PERFORMACE_RESULT_MODELS = r => require.ensure([], () => r(require('@/page/hvac/performance/result/models'), 'performance_result_models'));
const PERFORMACE_RESULT_EXPERIENCE = r => require.ensure([], () => r(require('@/page/hvac/performance/result/experience'), 'performance_result_experience'));
const PERFORMACE_RESULT_CONSTRUCT = r => require.ensure([], () => r(require('@/page/hvac/performance/result/construct'), 'performance_result_construct'));
const PERFORMACE_RESULT_OPERATE = r => require.ensure([], () => r(require('@/page/hvac/performance/result/operate'), 'performance_result_operate'));
const PERFORMACE_RESULT_LIST = r => require.ensure([], () => r(require('@/page/hvac/performance/result/list'), 'performance_result_list'));

const PERFORMACE_PROJECT_INDEX = r => require.ensure([], () => r(require('@/page/hvac/performance/project/index'), 'performance_project_index'));
const PERFORMACE_PROJECT_LIST = r => require.ensure([], () => r(require('@/page//hvac/performance/project/list'), 'performance_project_list'));
// 用户全流程交付在线
const USER_HOUSE_FINISH = r => require.ensure([], () => r(require('@/page/user/house/finish'), 'user_house_finish'));
const USER_HOUSE_FINISH_V2 = r => require.ensure([], () => r(require('@/page/member/v2/evaluate/finish'), 'user_house_finish_v2'));
const USER_HOUSE_EVALUATE_V2 = r => require.ensure([], () => r(require('@/page/member/v2/ievaluate/evaluate'), 'user_house_evaluate_v2'));
const USER_HOUSE_SURVEY = r => require.ensure([], () => r(require('@/page/user/house/survey'), 'user_house_survey'));
const USER_HOUSE_SURVEY_V2 = r => require.ensure([], () => r(require('@/page/member/v2/contract/survey'), 'user_house_survey_v2'));
const USER_HOUSE_RECOMMEND = r => require.ensure([], () => r(require('@/page/user/house/recommend'), 'user_house_recommend'));
const USER_HOUSE_RECOMMEND2 = r => require.ensure([], () => r(require('@/page/user/house/recommend2'), 'user_house_recommend2'));
const USER_HOUSE_PROSPECT = r => require.ensure([], () => r(require('@/page/user/house/prospect'), 'user_house_prospect'))
const MEMBER_DETAIL = r => require.ensure([], () => r(require('@/page/member/process/detail'), 'member_detail'))
const USER_HOUSE_RECOMMEND_DETAIL = r => require.ensure([], () => r(require('@/page/user/house/recommenddetail'), 'user_house_recommend_detail'));
// 用户交付在线
// const USER_DELINERY_ONLINE = r => require.ensure([], () => r(require('@/page/user/house/index'), 'user_delivery_online'));
const MEMBER_DELINERY_ONLINE = r => require.ensure([], () => r(require('@/page/member/index/index'), 'member_delivery_online'));
// 用户交付在线V2
const MEMBER_DELINERY_ONLINEV2 = r => require.ensure([], () => r(require('@/page/member/v2/index/index'), 'member_delivery_online_v2'));
const MEMBER_DELINERY_SCHEDULE = r => require.ensure([], () => r(require('@/page/member/v2/schedule/index'), 'member_delivery_schedule_v2'));

// 我的项目列表
const MEMBER_LISTS = r => require.ensure([], () => r(require('@/page/member/project/lists'), 'member_lists'));
// 全部项目列表V2
const V2_MEMBER_LISTS = r => require.ensure([], () => r(require('@/page/member/v2/project/lists'), 'v2_member_lists'));
// 承保书
const MEMBER_COVERNOTE = r => require.ensure([], () => r(require('@/page/member/covernote/index'), 'member_covernote'));
// 我的消息列表
const USER_MY_NRES = r => require.ensure([], () => r(require('@/page/member/mynews/index'), 'user_mynews'));
// 商用净水 授权
const MEMBER_COMMON_BUSINESS = r => require.ensure([], () => r(require('@/page/member/common/business'), 'member_business'));
// 勘察报告
const USER_REPORT = r => require.ensure([], () => r(require('@/page/member/project/mapping'), 'user_report'));
// 勘察报告v2
const USER_REPORT_V2 = r => require.ensure([], () => r(require('@/page/member/v2/project/mapping'), 'user_report'));
// 我的消息2.0
const MY_NEWS = r => require.ensure([], () => r(require('@/page/member/v2/mynews/index'), 'MY_NEWS'));
// user_info
const USER_INFO = r => require.ensure([], () => r(require('@/page/user/info'), 'user_info'));
//测试页面
const TEST = r => require.ensure([], () => r(require('@/page/test/index'), 'test'));
// 交付在线-交付报告列表2.0
const REPORT_V2 = r => require.ensure([], () => r(require('@/page/member/v2/process/index'), 'completionV2'));
const MEMBER_DETAIL_V2 = r => require.ensure([], () => r(require('@/page/member/v2/process/detail'), 'member_detail_v2'));
// 交付在线-施工标准2.0
const STANDARD_V2 = r => require.ensure([], () => r(require('@/page/member/v2/standard/index'), 'standardV2'));
// 交付在线-系统施工评价2.0
const EVALUATUION_V2 = r => require.ensure([], () => r(require('@/page/member/v2/evaluation/index'), 'standardV2'));
const TIPS = r => require.ensure([], () => r(require('@/page/project/antMap/tips'), 'tips'));

// bLog:true,  表示是否需要统计页面   authorize:true,   表示需要授权登录
const router = new Router({
    mode: "history",
    routes: [
        {
            path: "/test",
            name: "test",
            component: TEST,
            meta: {
                authorize: true,
                title: "分享图片",
            },
        },
        {
            path: "/antshare/index",
            name: "antshare",
            component: ANT_SHARE,
            meta: {
                title: "分享图片",
                authorize: true,
            },
        },
        {
            path: "/project/antMap/tips",
            name: "tips",
            component: TIPS,
            meta: {
                title: "潜客口碑阅读记录",
                authorize: true,
            },
        },
        // 业绩在线
        {
            path: "/performance/user/usermodel",
            name: "performance_user_usermodel",
            component: PERFORMACE_ONLINE,
            children: [
                {
                    path: "/performance/user/usermodel",
                    name: "performance_user_usermodel2",
                    component: PERFORMACE_USER_MODEL,
                    meta: {
                        title: "业绩在线",
                        authorize: true,
                    },
                    children: [
                        {
                            // 用户画像
                            path: "/performance/user/portrait",
                            name: "performance_user_portrait",
                            component: PERFORMACE_USER_PORTRAIT,
                            meta: {
                                title: "业绩在线",
                                authorize: true,
                            },
                        },
                        {
                            // 用户旅程
                            path: "/performance/user/journey",
                            name: "performance_user_journey",
                            component: PERFORMACE_USER_JOURNEY,
                            meta: {
                                title: "业绩在线",
                                authorize: true,
                            },
                        },
                        {
                            // 客户上线
                            path: "/performance/user/customer",
                            name: "performance_user_customer",
                            component: PERFORMACE_USER_CUSTOMER,
                            meta: {
                                title: "业绩在线",
                                authorize: true,
                            },
                        },
                        {
                            // 客户上线
                            path: "/performance/user/detailed",
                            name: "performance_user_detailed",
                            component: PERFORMACE_USER_DETAILED,
                            meta: {
                                title: "项目清单",
                                authorize: true,
                            },
                        },
                    ],
                },
                {
                    // 业绩
                    path: "/performance/result/analysis",
                    name: "performance_result_index",
                    component: PERFORMACE_RESULT_INDEX,
                    meta: {
                        title: "业绩在线",
                        authorize: true,
                    },
                    children: [
                        {
                            // 业绩分析
                            path: "/performance/result/analysis",
                            name: "performance_result_analysis",
                            component: PERFORMACE_RESULT_ANALYSIS,
                            meta: {
                                title: "业绩在线",
                                authorize: true,
                            },
                        },
                        {
                            // 渠道贡献
                            path: "/performance/result/channel",
                            name: "performance_result_channel",
                            component: PERFORMACE_RESULT_CHANNEL,
                            meta: {
                                title: "业绩在线",
                                authorize: true,
                            },
                        },
                        {
                            // 跟单分析
                            path: "/performance/result/documentary",
                            name: "performance_result_documentary",
                            component: PERFORMACE_RESULT_DOCUMENTARY,
                            meta: {
                                title: "业绩在线",
                                authorize: true,
                            },
                        },
                        {
                            // 机型占比
                            // /performance/result/models
                            path: "/performance/result/experience",
                            name: "performance_result_experience",
                            component: PERFORMACE_RESULT_EXPERIENCE,
                            meta: {
                                title: "业绩在线",
                                authorize: true,
                            },
                            children: [
                                {
                                    // 业绩分析
                                    path: "/performance/result/construct",
                                    name: "performance_result_construct",
                                    component: PERFORMACE_RESULT_CONSTRUCT,
                                    meta: {
                                        title: "建设情况",
                                        authorize: true,
                                    },
                                },
                                {
                                    // 业绩分析
                                    path: "/performance/result/operate",
                                    name: "performance_result_operate",
                                    component: PERFORMACE_RESULT_OPERATE,
                                    meta: {
                                        title: "运营情况",
                                        authorize: true,
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    path: "/performance/project/index",
                    name: "performance_project_index",
                    component: PERFORMACE_PROJECT_INDEX,
                    meta: {
                        title: "业绩在线",
                        authorize: true,
                    },
                },
                {
                    // 业绩清单
                    path: "/performance/result/list",
                    name: "performance_result_list",
                    component: PERFORMACE_RESULT_LIST,
                    meta: {
                        title: "业绩在线",
                        authorize: true,
                    },
                },
                {
                    // 项目清单
                    path: "/performance/project/list",
                    name: "performance_project_list",
                    component: PERFORMACE_PROJECT_LIST,
                    meta: {
                        title: "业绩在线",
                        authorize: true,
                    },
                },
            ],
        },
        // normal
        {
            path: "/other/poster/sales",
            name: "sales",
            component: SALES,
            meta: {
                authorize: true,
                title: "喜报",
            },
        },
        {
            path: "/other/xcx/business/info",
            name: "business",
            component: XCX_BUSINESS,
            meta: {
                authorize: true,
                title: "案例详情",
            },
        },
        {
            path: "/other/xcx/case/info",
            name: "business",
            component: XCX_CASE_INFO,
            meta: {
                authorize: true,
                title: "案例详情",
            },
        },
        {
            path: "/other/poster/share",
            name: "sharesales",
            component: SALES_SHARE,
            meta: {
                authorize: true,
                title: "喜报",
            },
        },
        // normal
        {
            path: "/other/poster/lookimg",
            name: "lookimg",
            component: LOOKIMG,
            meta: {
                authorize: true,
                title: "喜报",
            },
        },
        // normal
        {
            path: "/other/poster/lists",
            name: "poslist",
            component: POSLIST,
            meta: {
                authorize: true,
                title: "喜报",
            },
        },
        // normal
        {
            path: "/user/analysis/report",
            name: "analysis_report",
            component: ANALYSIS_REPORT,
            meta: {
                authorize: false,
                title: "A.O.史密斯",
            },
        },
        // normal
        {
            path: "/user/analysis/detail",
            name: "analysis_detail",
            component: ANALYSIS_DETAIL,
            meta: {
                authorize: false,
                title: "A.O.史密斯",
            },
        },
        //案例报表V2
        {
            path: "/user/analysisV2/report",
            name: "analysis_report_v2",
            component: ANALYSIS_REPORT_V2,
            meta: {
                authorize: false,
                title: "A.O.史密斯",
            },
        },
        //案例排行详情V2
        {
            path: "/user/analysisV2/detail",
            name: "analysis_detail_v2",
            component: ANALYSIS_DETAIL_V2,
            meta: {
                authorize: false,
                title: "A.O.史密斯",
            },
        },
        //商品详情
        // normal
        {
            path: "/shopp/details",
            name: "shoppdetails",
            component: SHOPP_DETAILS,
            meta: {
                authorize: false,
                title: "商品详情",
            },
        },
        // normal
        {
            path: "/shopp/list",
            name: "shopplist",
            component: SHOPP_LIST,
            meta: {
                authorize: true,
                title: "商品详情",
            },
        },
        {
            path: "/shoppcontent/index",
            name: "shoppcontent",
            component: SHOPP_CONTENT,
            meta: {
                title: "商品内容",
            },
        },
        // normal
        {
            path: "/contentdetails/index",
            name: "contentdetails",
            component: CONTENT_DETAIL,
            meta: {
                authorize: true,
                title: "商品内容",
            },
        },
        // normal
        {
            path: "/cms/release",
            name: "release",
            component: RELEASE,
            meta: {
                authorize: true,
                title: "A.O.史密斯",
            },
        },
        // normal
        {
            path: "/cms/preview",
            name: "preview",
            component: PREVIEW,
            meta: {
                authorize: true,
                title: "A.O.史密斯",
            },
        },
        // normal
        {
            path: "/cms/column",
            name: "column",
            component: COLUMN,
            meta: {
                authorize: true,
                title: "A.O.史密斯",
            },
        },
        // normal
        {
            path: "/case/index",
            name: "caseindex",
            component: CASEINDEX,
            meta: {
                authorize: false,
                title: "口碑地图",
            },
        },
        // {
        //     path: "/case/map/v2/lists", //列表模式复制升级版本
        //     name: "caseV1",
        //     component: CASE_LIST_v1,
        //     meta: {
        //         authorize: false,
        //         title: "口碑地图",
        //     },
        // },
        {
            path: "/case/map/v2/lists", //列表模式v2升级v3版本
            name: "caseV3",
            component: () => import("@/page/case/map/v3/lists"),
            meta: {
                authorize: false,
                title: "口碑地图",
            },
        },
        {
            path: "/case/map/v4/lists", //列表模式v2升级v3版本
            name: "caseV4",
            component: () => import("@/page/case/map/v4/index"),
            meta: {
                authorize: false,
                title: "口碑地图",
            },
        },
        // normal
        {
            path: "/casedetails/details",
            name: "casedetails",
            component: CASEDETAILS,
            meta: {
                authorize: false,
                title: "案例详情",
            },
        },
        // normal
        {
            path: "/case/map/v2/details",
            name: "casedetailsv2",
            component: CASEDETAILS_V2,
            meta: {
                authorize: false,
                title: "案例详情",
            },
        },
        {
            path: "/case/map/v2/store",
            name: "casestorelistv2",
            component: CASEDETAILSLIST_V2,
            meta: {
                authorize: false,
                title: "适用门店",
            },
        },
        // normal
        {
            path: "/casedetails/share",
            name: "casedetailsShare",
            component: CASEDETAILSSHARE,
            meta: {
                authorize: false,
                title: "案例详情",
            },
        },
        // normal
        {
            path: "/casedetails/sharelink",
            name: "casedetailsSharelink",
            component: CASEDETAILSSHARELINK,
            meta: {
                authorize: false,
                title: "案例详情",
            },
        },
        // normal
        {
            path: "/case_map/index",
            name: "caseMap",
            component: CASE_MAP,
            meta: {
                authorize: false,
                title: "口碑地图",
            },
        },
        // 口碑地图2.0
        // {
        //     path: "/case/map/v2/index",
        //     name: "caseMapV2",
        //     component: CASE_MAP_v2,
        //     meta: {
        //         authorize: false,
        //         title: "口碑地图",
        //     },
        // },
        {
            path: "/case/map/v2/index",
            name: "caseMapV3",
            component: () => import("@/page/case/map/v3/lists"),
            meta: {
                authorize: false,
                title: "口碑地图",
            },
        },
        {
            path: "/case/map/v4/lists", //列表模式v2升级v3版本
            name: "caseV4",
            component: () => import("@/page/case/map/v4/index"),
            meta: {
                authorize: false,
                title: "口碑地图",
            },
        },
        // 口碑地图旧版
        {
            path: "/case_map/v1/index",
            name: "caseMapCopy",
            component: CASE_MAP_v1,
            meta: {
                authorize: false,
                title: "口碑地图",
            },
        },
        // normal
        {
            path: "/casedraft/index",
            name: "casedraft",
            component: CASEDRAFT,
            meta: {
                authorize: false,
                title: "案例详情",
            },
        },
        {
            path: "/case/map/v2/special",
            name: "specialIndex",
            component: SPECIAL,
            meta: {
                authorize: false,
                title: "致总裁信",
            },
        },
        {
            path: "/case/map/v2/specialinfo",
            name: "specialinfo",
            component: SPECIAL_INFO,
            meta: {
                authorize: false,
                title: "A.O.史密斯",
            },
        },
        // normal
        {
            path: "/case/detail",
            name: "detail",
            component: DETAIL,
            meta: {
                authorize: false,
                title: "案例详情",
            },
        },
        // normal
        {
            path: "/case/detailshare",
            name: "olddetail",
            component: OLDDETAIL,
            meta: {
                authorize: false,
                title: "案例详情",
            },
        },
        // normal
        {
            path: "/case/detailimg",
            name: "olddetailimg",
            component: OLDDETAILIMG,
            meta: {
                authorize: false,
                title: "案例详情",
            },
        },
        // normal
        {
            path: "/system/report",
            name: "systemReport",
            component: SYSTEMREPORT,
            meta: {
                authorize: false,
                title: "方案报告",
            },
        },
        // fwb
        {
            path: "/user/share/report",
            name: "shareReport",
            component: () => import("@/page/user/share/report"),
            meta: {
                authorize: false,
                title: "项目数据",
            },
        },
        // fwb
        {
            path: "/user/share/office-select",
            name: "officeSelect",
            component: () => import("@/page/user/share/office-select"),
            meta: {
                authorize: false,
                title: "选择办事处",
            },
        },
        {
            path: "/project/detail/assess",
            component: () => import("@/page/project/detail/assess/assess"),
            name: "projectDetailAssess",
            meta: {
                authorize: false,
                title: "用户评价",
            },
        },
        {
            path: "/project/share/index",
            component: () => import("@/page/project/share/index"),
            name: "shareDetailIndex",
            meta: {
                authorize: false,
                title: "用户评价",
            },
        },
        {
            path: "/project/share/report",
            component: () => import("@/page/project/share/report"),
            name: "shareDetail",
            meta: {
                authorize: false,
                title: "用户评价",
            },
        },
        // fwb
        {
            path: "/project/detail/index",
            name: "projectDetail",
            component: () => import("@/page/project/detail/index"),
            redirect: "/project/detail/construction",
            children: [
                {
                    path: "/project/detail/custom",
                    component: () => import("@/page/project/detail/custom/custom"),
                    name: "projectDetailCustom",
                    meta: {
                        authorize: true,
                        title: "定制方案",
                    },
                },
                {
                    path: "/project/detail/construction",
                    component: () =>
                        import("@/page/project/detail/construction/construction"),
                    name: "projectDetailConstruction",
                    meta: {
                        authorize: true,
                        title: "工地直击",
                    },
                },
                {
                    path: "/project/detail/team",
                    component: () => import("@/page/project/detail/team/team"),
                    name: "projectDetailTeam",
                    meta: {
                        authorize: true,
                        title: "服务团队",
                    },
                },
                {
                    path: "/project/detail/evaluation",
                    component: () =>
                        import("@/page/project/detail/evaluation/evaluationV1"),
                    name: "projectDetailEvaluation",
                    meta: {
                        authorize: true,
                        title: "用户评价",
                    },
                },
            ],
            meta: {
                authorize: true,
                title: "案例详情",
            },
        },
        // 用户评价对接口--临时使用,
        {
            path: "/project/detail/evaluationV1",
            component: () => import("@/page/project/detail/evaluation/evaluationV1"),
            name: "projectDetailevaluationV1",
            meta: {
                authorize: false,
                title: "用户评价临时",
            },
        },
        // fwb 临时
        {
            path: "/project/detail/custom/image-view",
            name: "agentScoreSs",
            component: () => import("@/page/project/detail/custom/image-view"),
            meta: {
                authorize: false,
                title: "",
            },
        },
        // fwb--上海01
        {
            path: "/project/vr/shanghai/01/index",
            name: "VRInfo",
            component: () => import("@/page/project/vr/shanghai/01/index"),
            meta: {
                authorize: false,
            }
        },
        // 北京01
        {
            path: "/project/vr/beijing/01/index",
            name: "VRInfo",
            component: () => import("@/page/project/vr/beijing/01/index"),
            meta: {
                authorize: false,
            }
        },
        // fwb
        {
            path: "/hvac/agentscore/score",
            name: "agentScore",
            component: () => import("@/page/hvac/agentscore/score"),
            redirect: "/hvac/agentscore/analysis/score",
            meta: {
                authorize: true,
                title: "系统项目服务能力综合查询",
                name: "代理商得分",
            },
            children: [
                {
                    path: "/hvac/agentscore/analysis/score",
                    name: "customerScoringAnalysisScoreServe",
                    component: () => import("@/page/hvac/agentscore/analysis/score"),
                    meta: {
                        authorize: true,
                        title: "综合服务能力评分",
                        name: "全国冷暖风水服务能力评分",
                    },
                },
                {
                    path: "/hvac/agentscore/particulars",
                    name: "agentscoreparticulars",
                    component: () =>
                        import("@/page/hvac/agentscore/particulars"),
                    meta: {
                        authorize: true,
                        title: "综合服务能力评分",
                        name: "项目评分明细",
                    },
                },
                {
                    path: "/hvac/agentscore/question",
                    name: "customerScoringQuestionServe",
                    component: () => import("@/page/hvac/agentscore/question/index"),
                    meta: {
                        authorize: true,
                        title: "综合服务能力评分",
                        name: "高频问题排名",
                    },
                },
            ],
        },
        // fwb
        // {
        //     path: "/hvac/agentscore/particulars",
        //     name: "agentParticulars",
        //     component: () => import("@/page/hvac/agentscore/particulars"),
        //     meta: {
        //             authorize:true,
        //         title: "系统项目服务能力综合查询",
        //         name: "更多项目明细",
        //     },
        // },
        {
            path: "/service/higtproblems/proxytop",
            name: "proxytop",
            component: () => import("@/page/service/higtproblems/proxytop"),
            meta: {
                authorize: true,
                title: "综合服务能力评分",
            },
        },
        {
            path: "/service/higtproblems/proxytopitem",
            name: "proxytopitem",
            component: () => import("@/page/service/higtproblems/proxytopitem"),
            meta: {
                authorize: true,
                title: "系统项目服务能力综合查询",
            },
        },
        // fwb
        {
            path: "/hvac/customerscoring/index",
            name: "customerScoring",
            component: () => import("@/page/hvac/customerscoring/index"),
            redirect: "/hvac/customerscoring/analysis/index",
            meta: {
                authorize: true,
                title: "综合服务能力评分",
            },
            children: [
                {
                    path: "/hvac/customerscoring/analysis/index",
                    name: "customerScoringAnalysis",
                    component: () => import("@/page/hvac/customerscoring/analysis/index"),
                    redirect: "/hvac/customerscoring/analysis/score",
                    meta: {
                        authorize: true,
                        title: "综合服务能力评分",
                        name: "全国得分数据分析",
                    },
                    children: [
                        {
                            path: "/hvac/customerscoring/analysis/score",
                            name: "customerScoringAnalysisScore",
                            component: () =>
                                import("@/page/hvac/customerscoring/analysis/score"),
                            meta: {
                                authorize: true,
                                title: "综合服务能力评分",
                                name: "全国冷暖风水服务能力评分",
                            },
                        },
                        {
                            path: "/hvac/customerscoring/analysis/ranking",
                            name: "customerScoringAnalysisRanking",
                            component: () =>
                                import("@/page/hvac/customerscoring/analysis/ranking"),
                            meta: {
                                authorize: true,
                                title: "综合服务能力评分",
                                name: "服务商能力排名",
                            },
                        },
                    ],
                },
                {
                    path: "/hvac/customerscoring/particulars",
                    name: "customerscoringparticulars",
                    component: () =>
                        import("@/page/hvac/customerscoring/particulars"),
                    meta: {
                        authorize: true,
                        title: "综合服务能力评分",
                        name: "项目评分明细",
                    },
                },
                {
                    path: "/hvac/customerscoring/question",
                    name: "customerScoringQuestion",
                    component: () => import("@/page/hvac/customerscoring/question/index"),
                    meta: {
                        authorize: true,
                        title: "综合服务能力评分",
                        name: "高频问题排名",
                    },
                },
            ],
        },
        // wzh 用户卷宗报错页面
        {
            path: "/archives/error",
            name: "error",
            component: () => import("@/page/archives/error/index"),
            meta: {
                title: "暂无权限",
            }
        },
        // wzh  用户宗卷
        {
            path: "/hvac/dossier/warm",
            name: "warm",
            component: () => import("@/page/archives/warm/index"),
            meta: {
                authorize: true,
                title: "用户卷宗",
            }
        },
        // lzj  用户宗卷-详情
        {
            path: "/archives/dossier",
            name: "archives",
            component: () => import("@/page/archives/dossier/index"),
            meta: {
                authorize: true,
                title: "用户卷宗详情",
            },
            children: [
                {
                    path: "/archives/dossier/log", //跟进日志
                    name: "dossierLog",
                    component: () => import("@/page/archives/dossier/log/index"),
                    meta: {
                        authorize: true,
                        title: "用户卷宗详情",
                    },
                },
                // wcp 用户卷宗详情
                {
                    path: "/archives/survey/designinfo",
                    name: "workOrder",
                    component: () => import("@/page/archives/survey/designinfo"),
                    meta: {
                        authorize: true,
                        title: "用户卷宗详情",
                    },
                },
                {
                    path: "/archives/dossier/contract", //合同信息
                    name: "dossierContract",
                    component: () => import("@/page/archives/dossier/contract/index"),
                    meta: {
                        authorize: true,
                        title: "用户卷宗详情",
                    },
                },
                {
                    path: "/archives/dossier/aftersale", //售后维保
                    name: "dossierAftersale",
                    component: () => import("@/page/archives/dossier/aftersale/index"),
                    meta: {
                        authorize: true,
                        title: "售后维保",
                    },
                },
                {
                    path: "/archives/construction/index", //施工进度
                    name: "constructionIndex",
                    component: () => import("@/page/archives/dossier/construction/index"),
                    meta: {
                        authorize: true,
                        title: "施工进度",
                    },
                },
            ],
        },
        {
            path: "/archives/evaluate/index", //客户评价
            name: "evaluateIndex",
            component: () => import("@/page/archives/evaluate/index"),
            meta: {
                authorize: true,
                title: "客户评价",
            },
        },
        // lzj  用户宗卷-合同详情
        {
            path: "/archives/contract",
            name: "archivesContract",
            component: () => import("@/page/archives/contract/index"),
            meta: {
                authorize: true,
                title: "合同详情",
            }
        },// lzj  用户宗卷-跟进记录
        {
            path: "/archives/followup",
            name: "archivesFollowup",
            component: () => import("@/page/archives/followup/index"),
            meta: {
                authorize: true,
                title: "跟进记录",
            }
        },
        //lzj 用户卷宗-用户交付/口碑看板
        {
            path: "/archives/user/report",
            name: "archivesUserReport",
            component: () => import("@/page/archives/user/report.vue"),
            meta: {
                authorize: true,
                title: "用户交付/口碑看板",
            }
        },
        //lzj 用户卷宗-分享内容阅读记录
        {
            path: "/archives/user/record",
            name: "archivesUserReport",
            component: () => import("@/page/archives/user/record.vue"),
            meta: {
                authorize: true,
                title: "分享内容阅读记录",
            }
        },
        {
            path: "/archives/flow",
            name: "flow",
            component: () => import("@/page/archives/flow/index"),
            meta: {
                authorize: true,
                title: "工单详情",
            }
        },
        {
            path: "/archives/rectify",
            name: "rectify",
            component: () => import("@/page/archives/rectify/index"),
            meta: {
                authorize: true,
                title: "工单详情",
            }
        },
        {
            path: "/archives/disclose",
            name: "disclose",
            component: () => import("@/page/archives/disclose/index"),
            meta: {
                authorize: true,
                title: "工单详情",
            }
        },
        {
            path: "/archives/contract/record",
            name: "archivesContract",
            component: () => import("@/page/archives/contract/record"),
            meta: {
                authorize: true,
                title: "变更记录",
            }
        },
        // wcp 勘察报告详情
        {
            path: "/archives/survey/reportinfo",
            name: "reportinfo",
            component: () => import("@/page/archives/survey/reportinfo"),
            meta: {
                authorize: true,
                title: "勘察报告",
            },
        },
        // gw 客户详情v1
        {
            path: "/hvac/talk/customer",
            name: "talkRecord",
            component: () => import("@/page/hvac/talk/customer"),
            meta: {
                authorize: true,
                title: "客户详情",
            },
            children: [
                {
                    path: "/hvac/talk/record",
                    name: "talkRecord2",
                    component: () => import("@/page/hvac/talk/record"),
                    meta: {
                        authorize: true,
                        title: "洽谈记录",
                    },
                },
            ],
        },
        // gw 客户详情v2
        {
            path: "/hvac/talk/customer",
            name: "talkRecord",
            component: () => import("@/page/hvac/talk/v2/record/customer"),
            meta: {
                authorize: true,
                title: "客户详情",
            },
            children: [
                {
                    path: "/hvac/talk/record",
                    name: "talkRecordV2",
                    component: () => import("@/page/hvac/talk/record"),
                    meta: {
                        authorize: true,
                        title: "洽谈记录",
                    },
                },
            ],
        },
        // 签到v1
        {
            path: "/hvac/talk/v1/signIn",
            name: "signIn",
            component: () => import("@/page/hvac/talk/signIn"),
            meta: {
                authorize: true,
                title: "签到打卡",
            },
        },
        // 签到v2
        {
            path: "/hvac/talk/signIn",
            name: "signInV2",
            component: () => import("@/page/hvac/talk/v2/appoint/children/signIn"),
            meta: {
                authorize: true,
                title: "签到打卡",
            },
        },
        // 分享
        {
            path: "/hvac/talk/share",
            name: "signInV2",
            component: () => import("@/page/hvac/talk/v2/appoint/share.vue"),
            meta: {
                authorize: true,
                title: "",
            },
        },
        {
            path: "/hvac/talk/ckdetail",
            name: "ckdetailV2",
            component: () => import("@/page/hvac/talk/v2/appoint/children/ckdetail"),
            meta: {
                authorize: true,
                title: "体验间点检",
            },
        },
        // 体验间v2
        {
            path: "/hvac/talk/cktime",
            name: "cktimeV2",
            component: () => import("@/page/hvac/talk/v2/appoint/children/cktime"),
            meta: {
                authorize: true,
                title: "点检记录",
            },
        },
        // 体验反馈v1和v2都跳这里
        {
            path: "/hvac/talk/feedback",
            name: "feedbackV2",
            component: () => import("@/page/hvac/talk/v2/appoint/children/feedback"),
            meta: {
                authorize: true,
                title: "体验反馈",
            },
        },
        {
            path: "/user/inviation/agree",
            name: "agree",
            component: () => import("@/page/user/inviation/agree"),
            meta: {
                authorize: true,
                title: "隐私协议",
            },
        },
        // gw 体验预约v1
        {
            path: "/hvac/talk/v1/appoint",
            name: "appoint",
            component: () => import("@/page/hvac/talk/appoint"),
            meta: {
                authorize: true,
                title: "体验预约",
            },
            children: [
                {
                    path: "/hvac/talk/v1/appoint",
                    name: "appointMain",
                    component: () => import("@/page/hvac/talk/appointMain"),
                    meta: {
                        authorize: true,
                        title: "体验预约",
                    },
                },
                {
                    path: "/hvac/talk/v1/myappoint",
                    name: "myappoint",
                    component: () => import("@/page/hvac/talk/myappoint"),
                    meta: {
                        authorize: true,
                        title: "我的预约",
                    },
                },
            ],
        },
        // wcp 体验预约v2
        {
            path: "/hvac/talk/appoint",
            name: "appointV2",
            component: () => import("@/page/hvac/talk/v2/appoint/appoint"),
            meta: {
                authorize: true,
                title: "体验预约",
            },
            children: [
                {
                    path: "/hvac/talk/appoint",
                    name: "appointMainV2",
                    component: () => import("@/page/hvac/talk/v2/appoint/appointMain"),
                    meta: {
                        authorize: true,
                        title: "体验预约",
                    },
                },
                {
                    path: "/hvac/talk/myappoint",
                    name: "myappointV2",
                    component: () => import("@/page/hvac/talk/v2/appoint/myappoint"),
                    meta: {
                        authorize: true,
                        title: "我的预约",
                    },
                },
                {
                    path: "/hvac/talk/check",
                    name: "checkV2",
                    component: () => import("@/page/hvac/talk/v2/appoint/check"),
                    meta: {
                        authorize: true,
                        title: "体验间点检",
                    },
                },
            ],
        },
        // wcp 体验间v3
        {
            path: "/hvac/talk/v3/feedback",
            name: "feedbackV3",
            component: () => import("@/page/hvac/talk/v3/appoint/children/feedback"),
            meta: {
                authorize: true,
                title: "体验反馈",
            },
        },
        {
            path: "/hvac/talk/v3/ckdetail",
            name: "ckdetailv3",
            component: () => import("@/page/hvac/talk/v3/appoint/children/ckdetail"),
            meta: {
                authorize: true,
                title: "体验间点检",
            },
        },
        {
            path: "/user/inviation/v3/inviation",
            name: "inviation",
            component: () => import("@/page/user/inviation/v3/invite.vue"),
            // invite
            meta: {
                authorize: true,
                title: "邀请函",
            },
        },
        {
            path: "/hvac/talk/v3/scanning",
            name: "scanning",
            component: () => import("@/page/hvac/talk/v3/appoint/children/scanning"),
            meta: {
                authorize: true,
                title: "A.O.史密斯",
            },
        },
        {
            path: "/hvac/talk/v3/clockIn",
            name: "clockIn",
            component: () => import("@/page/hvac/talk/v3/appoint/children/clockIn"),
            meta: {
                authorize: true,
                title: "签到打卡",
            },
        },
        {
            path: "/hvac/talk/v3/cktime",
            name: "cktimev3",
            component: () => import("@/page/hvac/talk/v3/appoint/children/cktime"),
            meta: {
                authorize: true,
                title: "点检记录",
            },
        },
        {
            path: "/hvac/talk/v3/appoint",
            name: "appointV2",
            component: () => import("@/page/hvac/talk/v3/appoint/appoint"),
            meta: {
                authorize: true,
                title: "体验预约",
            },
            children: [
                {
                    path: "/hvac/talk/v3/writeoff",
                    name: "cktimev3",
                    component: () => import("@/page/hvac/talk/v3/appoint/writeoff"),
                    meta: {
                        authorize: true,
                        title: "预约核销",
                    },
                },
                {
                    path: "/hvac/talk/v3/appoint",
                    name: "appointMainV3",
                    component: () => import("@/page/hvac/talk/v3/appoint/appointMain"),
                    meta: {
                        authorize: true,
                        title: "体验预约",
                    },
                },
                {
                    path: "/hvac/talk/v3/myappoint",
                    name: "myappointV3",
                    component: () => import("@/page/hvac/talk/v3/appoint/myappoint"),
                    meta: {
                        authorize: true,
                        title: "我的预约",
                    },
                },
                {
                    path: "/hvac/talk/v3/check",
                    name: "checkV3",
                    component: () => import("@/page/hvac/talk/v3/appoint/check"),
                    meta: {
                        authorize: true,
                        title: "体验间点检",
                    },
                },
            ],
        },
        // 邀请函v1
        {
            path: "/user/invitation/v1/invitation",
            name: "invitation",
            component: () => import("@/page/user/inviation/invitation"),
            meta: {
                authorize: true,
                title: "邀请函",
            },
        },
        // 邀请函v2
        {
            path: "/user/invitation/invitation",
            name: "invitation",
            component: () => import("@/page/user/inviation/v2/invitation"),
            meta: {
                authorize: true,
                title: "邀请函",
            },
        },
        // fwb 上门勘察 录入
        {
            path: "/hvac/mapping/entry",
            name: "prospectEntry",
            component: () => import("@/page/hvac/mapping/entry"),
            meta: {
                authorize: true,
                title: "上门勘察",
            },
        },
        {
            path: "/service/scoredetail/index",
            name: "scoredetail",
            component: () => import("@/page/service/scoredetail/index"),
            children: [
                {
                    path: "/service/scoredetail/index",
                    name: "scoredetail1",
                    component: () => import("@/page/service/scoredetail/dataFx"),
                    meta: {
                        authorize: true,
                        title: "项目评分详细",
                    },
                },
                {
                    path: "/service/scoredetail/questionanalysis",
                    name: "scoredetail2",
                    component: () => import("@/page/service/scoredetail/questionFx"),
                    meta: {
                        authorize: true,
                        title: "项目评分详细",
                    },
                },
            ],
            meta: {
                authorize: true,
                title: "项目评分详细",
            },
        },
        //lzj 项目案例3.0
        {
            path: "/project/v3/login/index",
            name: "projectLogin",
            component: () => import("@/page/project/v3/login/index"),
            meta: {
                qyauthorize: false,
                title: "A.O.史密斯",
            },
        },
        {
            path: "/project/v3/case/index",
            name: "projectCase",
            component: () => import("@/page/project/v3/case/index"),
            meta: {
                qyauthorize: true,
                title: "A.O.史密斯",
            },
        },
        {
            path: "/project/v3/case/details",
            name: "caseDetailsV3",
            component: () => import("@/page/project/v3/case/details"),
            meta: {
                qyauthorize: true,
                title: "A.O.史密斯",
            },
        },
        {
            path: "/project/v3/case/preview",
            name: "casePreview",
            component: () => import("@/page/project/v3/case/preview"),
            meta: {
                // qyauthorize: true,
                title: "工地直击",
            },
        },
        {
            path: "/project/v3/case/edit",
            name: "caseEdit",
            component: () => import("@/page/project/v3/case/edit"),
            meta: {
                // qyauthorize: true,
                title: "工地直击",
            },
        },
        {
            path: "/project/v3/discuss/index",
            name: "projectDiscuss",
            component: () => import("@/page/project/v3/discuss/index"),
            meta: {
                qyauthorize: true,
                title: "用户评论",
            },
        },
        {
            path: "/project/v3/share/index",
            name: "discussShare",
            component: () => import("@/page/project/v3/share/index"),
            meta: {
                qyauthorize: true,
                title: "用户评论",
            },
        },
        {
            path: "/project/v3/word/index",
            name: "discussShare",
            component: () => import("@/page/project/v3/word/index"),
            meta: {
                qyauthorize: true,
                title: "项目详情",
            },
        },
        {
            path: "/project/v3/word/preview",
            name: "caseDetails",
            component: () => import("@/page/project/v3/word/preview"),
            meta: {
                // qyauthorize: false,
                title: "项目详情",
            },
        },
        {
            path: "/project/v3/tips/index",
            name: "discussShare",
            component: () => import("@/page/project/v3/tips/index"),
            meta: {
                qyauthorize: true,
                title: "潜客口碑阅读记录",
            },
        },
        //lzj 项目案例3.0-pad
        {
            path: "/project/plan/case/index",
            name: "projectCase",
            component: () => import("@/page/project/plan/case/index"),
            meta: {
                title: "A.O.史密斯",
            },
        },
        {
            path: "/project/plan/case/details",
            name: "caseDetailsV3",
            component: () => import("@/page/project/plan/case/details"),
            meta: {
                title: "A.O.史密斯",
            },
        },
        {
            path: "/project/plan/discuss/index",
            name: "projectDiscuss",
            component: () => import("@/page/project/plan/discuss/index"),
            meta: {
                title: "用户评论",
            },
        },
        {
            path: "/project/plan/word/index",
            name: "discussShare",
            component: () => import("@/page/project/plan/word/index"),
            meta: {
                title: "项目详情",
            },
        },
        {
            path: "/project/plan/tips/index",
            name: "discussShare",
            component: () => import("@/page/project/plan/tips/index"),
            meta: {
                qyauthorize: true,
                title: "潜客口碑阅读记录",
            },
        },
        //交互中心申请权限
        // {
        //     path: "/user/apply/pad",
        //     name: "padApply",
        //     component: () => import("@/page/user/apply/pad"),
        //     meta: {
        //         authorize: true,
        //         title: "A.O.史密斯",
        //     },
        // },
        // 艾暖通 normal
        {
            path: "/antmap/index",
            name: "antMap",
            component: ANT_MAP,
            meta: {
                authorize: true,
                title: "A.O.史密斯",
            },
        },
        {
            path: "/ant/parameter",
            name: "antParameter",
            component: ANTPARAMETER,
            meta: {
                authorize: true,
                title: "参数设置",
            },
        },
        {
            path: "/ant/parameter/v2",
            name: "antParameter",
            component: ANTPARAMETER_V2,
            meta: {
                authorize: true,
                title: "参数设置",
            },
        },
        {
            path: "/ant/end",
            name: "antEnd",
            component: ANTEND,
            meta: {
                authorize: true,
                title: "选型配置",
            },
        },
        {
            path: "/ant/end/v2",
            name: "antEnd",
            component: ANTEND_V2,
            meta: {
                authorize: true,
                title: "选型配置",
            },
        },
        {
            path: "/ant/selection",
            name: "antSelectiopn",
            component: ANTSELECTION,
            meta: {
                authorize: true,
                title: "选型配置",
            },
        },
        {
            path: "/ant/selection/v2",
            name: "antSelectiopn",
            component: ANTSELECTION_V2,
            meta: {
                authorize: true,
                title: "选型配置",
            },
        },
        {
            path: "/ant/scheme",
            name: "antScheme",
            component: ANTSCHEME,
            meta: {
                authorize: true,
                title: "方案书预览",
            },
        },
        {
            path: "/ant/scheme/v2",
            name: "antScheme",
            component: ANTSCHEME_V2,
            meta: {
                authorize: true,
                title: "方案书预览",
            },
        },
        {
            path: "/ant/editscheme",
            name: "antEditScheme",
            component: ANTEDITSCHEME,
            meta: {
                authorize: true,
                title: "方案书编辑",
            },
        },
        {
            path: "/antinfo/index",
            name: "antInfo",
            component: ANT_INFO,
            meta: {
                authorize: true,
                title: "用户列表",
            },
        },
        {
            path: "/antinfo/project",
            name: "antProject",
            component: ANT_PROJECT,
            meta: {
                authorize: true,
                title: "项目清单",
            },
        },
        {
            path: "/antinfo/submit",
            name: "antInfoSubmit",
            component: ANT_SUBMIT,
            meta: {
                authorize: true,
                title: "项目清单",
            },
        },
        // normal
        {
            path: "/antdetails/index",
            name: "antDetails",
            component: ANT_DETAILS,
            meta: {
                authorize: true,
                title: "项目详情",
            },
        },
        {
            path: "/project/antdetails/assess",
            component: () => import("@/page/project/antdetails/assess"),
            name: "projectAntdetailsAssess",
            meta: {
                authorize: false,
                title: "用户评价",
            },
        },
        {
            path: "/canvasimg/index",
            name: "canvasimg",
            component: CANVAS_DETAILS,
            meta: {
                authorize: true,
                title: "项目详情",
            },
        },
        {
            path: "/ant/error",
            name: "antError",
            component: ANTERROR,
            meta: {
                authorize: false,
                title: "发生错误",
            },
        },
        {
            path: "/ant/offter",
            name: "antOffter",
            component: ANTOFFTER,
            meta: {
                authorize: true,
                title: "报价",
            },
        },
        {
            path: "/ant/offter/v2",
            name: "antOffter",
            component: ANTOFFTER_V2,
            meta: {
                authorize: true,
                title: "报价",
            },
        },
        // 艾暖通v2v2
        {
            path: "/antV2/basicinfo",
            name: "basicinfo",
            component: BASIC_INFO,
            meta: {
                authorize: true,
                title: "基础信息",
            },
        },
        {
            path: "/antV2/basicinfo/v2",
            name: "basicinfo",
            component: BASIC_INFO_V2,
            meta: {
                authorize: true,
                title: "基础信息",
            },
        },
        {
            path: "/pdf/pdfindex",
            name: "pdfindex",
            component: PDF,
            meta: {
                authorize: true,
                title: "pdf",
            },
        },
        {
            path: "/pdf/sharepdf",
            name: "sharepdf",
            component: PDFIFRAME,
            meta: {
                authorize: true,
                title: "PDF预览",
            },
        },
        // 用户交付在线
        {
            path: "/member/index/index",
            name: "memberindex",
            component: MEMBER_DELINERY_ONLINE,
            meta: {
                bLog: true,
                authorize: true,
                title: "项目交付档案",
            },
        },
        // app端-用户交付在线v3 - 首页
        {
            path: "/member/v3/index/index",
            name: "memberindexv3",
            component: () => import("@/page/member/appv3/index/index"),
            meta: {
                bLog: true,
                authorize: false,
                title: "项目交付档案",
            },
        },
        // 用户交付在线v2 - 首页
        {
            path: "/member/v2/index/index",
            name: "memberindexv2",
            component: MEMBER_DELINERY_ONLINEV2,
            meta: {
                bLog: true,
                authorize: true,
                title: "项目交付档案",
            },
        },
        // 测试企业微信 - gw
        {
            path: "/test/wechatcom",
            name: "wechatcom",
            component: () => import('@/page/member/v2/test/know'),
            meta: {
                bLog: true,
                authorize: true,
                title: "测试企业微信打开",
            },
        },
        //用户交付在线v2 - 进度
        {
            path: "/member/v2/schedule/index",
            name: "memberschedule",
            component: MEMBER_DELINERY_SCHEDULE,
            meta: {
                bLog: true,
                authorize: true,
                title: "用户交付在线",
            },
        },
        //用户交付在线v3 - 进度
        {
            path: "/member/v3/schedule/index",
            name: "memberschedulev3",
            component: () => import('@/page/member/appv3/schedule/index'),
            meta: {
                bLog: true,
                authorize: false,
                title: "用户交付在线",
            },
        },
        {
            // 我的项目
            path: "/member/project/lists",
            name: "memberlists",
            component: MEMBER_LISTS,
            meta: {
                bLog: true,
                authorize: true,
                title: "我的交付书",
            },
        },
        {
            // 全部项目
            path: "/member/v2/project/lists",
            name: "memberlists",
            component: V2_MEMBER_LISTS,
            meta: {
                bLog: true,
                authorize: true,
                title: "全部项目",
            },
        },
        {
            // 全部项目
            path: "/member/v3/project/lists",
            name: "memberlistsv3",
            component: () => import('@/page/member/appv3/project/lists'),
            meta: {
                bLog: true,
                authorize: false,
                title: "全部项目",
            },
        },
        {
            // 我的项目
            path: "/member/covernote/index",
            name: "covernote",
            component: MEMBER_COVERNOTE,
            meta: {
                bLog: true,
                authorize: true,
                title: "承保书",
            },
        },
        {
            // 我的消息
            path: "/member/mynews/index",
            name: "mynews",
            component: USER_MY_NRES,
            meta: {
                bLog: true,
                authorize: true,
                title: "我的消息",
            },
        },
        {
            // 商用用水 -
            path: "/member/common/business",
            name: "business",
            component: MEMBER_COMMON_BUSINESS,
            meta: {
                bLog: true,
                authorize: true,
                title: "",
            },
        },
        {
            // 勘察报告
            path: "/member/project/mapping",
            name: "houseReport",
            component: USER_REPORT,
            meta: {
                bLog: true,
                authorize: true,
                title: "勘察报告",
            },
        },
        {
            // 勘察报告
            path: "/member/v2/project/mapping",
            name: "houseReport",
            component: USER_REPORT_V2,
            meta: {
                bLog: true,
                authorize: true,
                title: "勘察报告",
            },
        },
        {
            // 我的消息
            path: "/member/v2/mynews/index",
            name: "mynews",
            component: MY_NEWS,
            meta: {
                bLog: true,
                authorize: true,
                title: "我的消息",
            },
        },
        {
            // 我的消息
            path: "/member/v3/mynews/index",
            name: "mynewsv3",
            component: () => import('@/page/member/appv3/mynews/index'),
            meta: {
                bLog: true,
                authorize: false,
                title: "我的消息",
            },
        },
        {
            // 施工报告2.0
            path: "/member/v2/process/index",
            name: "completionV2",
            component: REPORT_V2,
            meta: {
                bLog: true,
                authorize: true,
                title: '施工验收交付报告'
            },
        },
        {
            // 施工报告2.0
            path: "/member/v3/process/index",
            name: "completionV3",
            component: () => import('@/page/member/appv3/process/index'),
            meta: {
                bLog: true,
                authorize: false,
                title: '施工验收交付报告'
            },
        },
        {
            // 施工标准2.0
            path: "/member/v2/standard/index",
            name: "standardV2",
            component: STANDARD_V2,
            meta: {
                bLog: true,
                authorize: true,
                title: "施工标准",
            },
        },
        {
            // 施工标准2.0
            path: "/member/v3/standard/index",
            name: "standardV3",
            component: () => import('@/page/member/appv3/standard/index'),
            meta: {
                bLog: true,
                authorize: false,
                title: "施工标准",
            },
        },
        {
            // 系统施工评价2.0
            path: "/member/v2/evaluation/index",
            name: "evaluationV2",
            component: EVALUATUION_V2,
            meta: {
                bLog: true,
                authorize: true,
                title: "系统施工评价",
            },
        },
        {
            // 系统施工评价2.0
            path: "/member/v3/evaluation/index",
            name: "evaluationV3",
            component: () => import('@/page/member/appv3/evaluation/index'),
            meta: {
                bLog: true,
                authorize: false,
                title: "系统施工评价",
            },
        },
        {
            // 项目方案书
            path: "/member/project/plan",
            name: "houseReport",
            component: () => import("@/page/member/project/plan/index"),
            meta: {
                bLog: true,
                authorize: true,
                title: "项目方案书",
            },
        },
        {
            // 项目方案书v2
            path: "/member/v2/project/plan",
            name: "houseReport",
            component: () => import("@/page/member/v2/project/plan/index"),
            meta: {
                bLog: true,
                authorize: true,
                title: "项目方案书",
            },
        },
        {
            // 项目方案书v2
            path: "/member/v3/project/plan",
            name: "houseReport",
            component: () => import("@/page/member/appv3/project/plan/index"),
            meta: {
                bLog: true,
                authorize: false,
                title: "项目方案书",
            },
        },
        {
            // 项目方案书历史版本v2
            path: "/member/v2/project/version",
            name: "version",
            component: () => import("@/page/member/v2/project/plan2/version"),
            meta: {
                bLog: true,
                authorize: true,
                title: "历史版本",
            },
        },
        {
            // 项目方案书v2末端配置详情
            path: "/member/v2/project/endconfig",
            name: "endConfig",
            component: () => import("@/page/member/v2/project/plan2/endconfig"),
            meta: {
                bLog: true,
                authorize: true,
                title: "末端选型配置清单",
            },
        },
        {
            // 项目方案书
            path: "/member/standard/index",
            name: "standard",
            component: () => import("@/page/member/standard/index"),
            meta: {
                bLog: true,
                authorize: true,
                title: "冷暖风水系统质量管理标准",
            },
        },
        {
            path: "/user/house/finish",
            name: "finish",
            component: USER_HOUSE_FINISH,
            meta: {
                authorize: true,
                title: "竣工评价",
            },
        },
        {
            path: "/member/v2/evaluate/finish",
            name: "finish",
            component: USER_HOUSE_FINISH_V2,
            meta: {
                authorize: true,
                title: "竣工验收评价",
            },
        },
        {
            path: "/member/v3/evaluate/finish",
            name: "finishv3",
            component: () => import("@/page/member/appv3/evaluate/finish.vue"),
            meta: {
                authorize: false,
                title: "竣工验收评价",
            },
        },
        {
            path: "/member/v2/ievaluate/evaluate",
            name: "evaluate",
            component: USER_HOUSE_EVALUATE_V2,
            meta: {
                authorize: true,
                title: "系统施工评价",
            },
        },
        {
            path: "/member/v3/ievaluate/evaluate",
            name: "evaluatev3",
            component: () => import("@/page/member/appv3/ievaluate/evaluate.vue"),
            meta: {
                authorize: false,
                title: "系统施工评价",
            },
        },
        {
            path: "/user/house/survey",
            name: "survey",
            component: USER_HOUSE_SURVEY,
            meta: {
                authorize: true,
                title: "合同备忘",
            },
        },
        {
            path: "/member/v2/contract/survey",
            name: "survey",
            component: USER_HOUSE_SURVEY_V2,
            meta: {
                authorize: true,
                title: "设备清单",
            },
        },
        {
            path: "/member/v3/contract/survey",
            name: "surveyv3",
            component: () => import("@/page/member/appv3/contract/survey.vue"),
            meta: {
                authorize: false,
                title: "设备清单",
            },
        },
        {
            path: "/user/house/recommend",
            name: "recommend",
            component: USER_HOUSE_RECOMMEND,
            meta: {
                authorize: true,
                title: "我要推荐",
            },
        },
        {
            path: "/user/house/recommend2",
            name: "recommend_list",
            component: USER_HOUSE_RECOMMEND2,
            meta: {
                authorize: true,
                title: "我要推荐",
            },
        },
        {
            path: "/user/house/recommenddetail",
            name: "recommend_detail",
            component: USER_HOUSE_RECOMMEND_DETAIL,
            meta: {
                authorize: true,
                title: "我要推荐",
            },
        },
        // fwb
        {
            path: "/user/house/projectteam",
            name: "projectTeam",
            component: () => import("@/page/user/house/projectteam"),
            meta: {
                authorize: true,
                title: "项目团队",
            },
        },
        {
            path: "/member/v2/team/index",
            name: "projectTeam",
            component: () => import("@/page/member/v2/team/index"),
            meta: {
                authorize: true,
                title: "项目团队",
            },
        },
        {
            path: "/member/v3/team/index",
            name: "projectTeamv3",
            component: () => import("@/page/member/appv3/team/index"),
            meta: {
                authorize: false,
                title: "项目团队",
            },
        },
        {
            path: "/member/v2/programme/index",
            name: "projectTeam",
            component: () => import("@/page/member/v2/programme/index"),
            meta: {
                authorize: true,
                title: "3D设计方案",
            },
        },
        {
            path: "/member/v3/programme/index",
            name: "projectTeamv3",
            component: () => import("@/page/member/appv3/programme/index"),
            meta: {
                authorize: false,
                title: "3D设计方案",
            },
        },
        //lzj 选择分享给客户还是设计师
        {
            path: "/pick/share",
            name: "pickShare",
            component: () => import("@/page/designer/pick/share"),
            meta: {
                authorize: false,
                title: "A.O.史密斯",
            },
        },
        //lzj 交付在线-设计师
        {
            path: "/designer/index/index",
            name: "designerIndex",
            component: () => import("@/page/designer/index/index"),
            meta: {
                authorize: false,
                title: "首页",
            },
        }, {
            path: "/designer/venting/index",
            name: "designerIndex",
            component: () => import("@/page/designer/venting/index"),
            meta: {
                authorize: false,
                title: "我要吐槽",
            },
        },
        {
            path: "/designer/testaoauth/index",
            name: "designerIndex",
            component: () => import("@/page/designer/testaoauth/index"),
            meta: {
                authorize: false,
                title: "艾欧圈授权测试",
            },
        },
        {
            path: "/designer/project/index",
            name: "designerIndex",
            component: () => import("@/page/designer/project/index"),
            meta: {
                authorize: false,
                title: "项目交付书",
            },
        },
        {
            path: "/designer/evaluation/index",
            name: "designerevaluation",
            component: () => import("@/page/designer/evaluation/index"),
            meta: {
                authorize: false,
                title: "项目评价",
            },
        },
        {
            path: "/designer/team/index",
            name: "designerTeam",
            component: () => import("@/page/designer/team/index"),
            meta: {
                authorize: false,
                title: "项目团队",
            },
        },
        {
            path: "/designer/standard/index",
            name: "designerStandard",
            component: () => import("@/page/designer/standard/index"),
            meta: {
                authorize: false,
                title: "施工标准",
            },
        },
        {
            path: "/designer/process/index",
            name: "designerProcess",
            component: () => import("@/page/designer/process/index"),
            meta: {
                authorize: false,
            },
        },
        {
            path: "/designer/contract/index",
            name: "designerContract",
            component: () => import("@/page/designer/contract/index"),
            meta: {
                authorize: false,
                title: "合同备忘",
            },
        },
        {
            path: "/designer/designer3d/index",
            name: "designer3d",
            component: () => import("@/page/designer/designer3d/index"),
            meta: {
                authorize: false,
                title: "3D设计方案",
            },
        },
        {
            path: "/designer/xcx/business",
            name: "jump",
            component: () => import("@/page/designer/xcx/business"),
            meta: {
                authorize: false,
                title: "A.O.史密斯",
            },
        },
        // fwb
        {
            path: "/user/house/completion",
            name: "CompletionEva",
            component: () => import("@/page/user/house/completion"),
            meta: {
                authorize: true,
                title: "个人项目中心",
            },
        },
        {
            path: "/user/house/completed",
            name: "CompletionLeted",
            component: () => import("@/page/user/house/completed"),
            meta: {
                authorize: true,
                title: "竣工评价",
            },
        },
        {
            path: "/user/house/prospect",
            name: "user_house_prospect",
            component: USER_HOUSE_PROSPECT,
            meta: {
                authorize: true,
                title: "定位交底",
            },
        },
        {
            path: "/user/info/index",
            name: "user_info_index",
            component: USER_INFO,
            meta: {
                authorize: true,
                title: "user-info",
            },
        },
        {
            path: "/member/process/index",
            name: "processIndex",
            component: () => import("@/page/member/process/index"),
            meta: {
                bLog: true,
                authorize: true,
                title: "个人项目中心",
            },
        },
        {
            path: "/jump/xcx/business",
            name: "jump",
            component: () => import("@/page/jump/xcx/business"),
            meta: {
                authorize: false,
                title: "A.O.史密斯",
            },
        },
        {
            path: "/member/process/detail",
            name: "member_detail",
            component: MEMBER_DETAIL,
            meta: {
                bLog: true,
                authorize: true,
            }
        },
        {
            path: "/member/v3/process/detail",
            name: "member_detail_v3",
            component: () => import("@/page//member/appv3/process/detail"),
            meta: {
                bLog: true,
                authorize: false,
            }
        },
        {
            path: "/member/v2/process/detail",
            name: "member_detail_v2",
            component: MEMBER_DETAIL_V2,
            meta: {
                bLog: true,
                authorize: true,
            }
        },
        {
            path: "/other/project-detail/index",
            name: "project_detail",
            component: () => import("@/page/other/project-detail/index"),
            meta: {
                authorize: true,
                title: "案例详情",
            },
        },
        {
            path: "/case/share/index",
            name: "caseShare",
            component: () => import("@/page/case/share/index"),
            meta: {
                authorize: false,
                title: "口碑案例长图",
            },
        },
        {
            path: "/aosmithsdk/index",
            name: "caseShare",
            component: () => import("@/page/aosmithsdk/index"),
            meta: {
                authorize: false,
                title: "微信云开发sdk示例",
            },
        },
        // 工单详情
        {
            path: "/archives/workOrder/details",
            name: "order",
            component: () => import("@/page/archives/order/details"),
            meta: {
                authorize: true,
                title: "工单详情",
            },
        },
        // 3D设计方案
        {
            path: "/archives/design/details",
            name: "design",
            component: () => import("@/page/archives/design/details"),
            meta: {
                authorize: true,
                title: "3D设计方案",
            },
        },
        // 变更记录
        {
            path: "/archives/design/change",
            name: "change",
            component: () => import("@/page/archives/design/change"),
            meta: {
                authorize: true,
                title: "变更记录",
            },
        },
        {
            path: "/voice/test",
            name: "voiceTest",
            component: () => import("@/page/member/v2/test/test"),
            meta: {
                authorize: true,
                title: "录音权限测试",
            },
        },
        {
            path: "/track/index",
            name: "trackIndex",
            component: () => import("@/page/track/index"),
            meta: {
                authorize: true,
                title: "A.0.史密斯",
            },
            children: [
                {
                    path: "/track/developer",
                    name: "developer",
                    component: () => import("@/page/track/developer"),
                    meta: {
                        authorize: true,
                        title: "开发者看板",
                    }
                },
                {
                    path: "/track/management",
                    name: "management",
                    component: () => import("@/page/track/management"),
                    meta: {
                        authorize: true,
                        title: "管理看板",
                    }
                },
                {
                    path: "/track/seller",
                    name: "seller",
                    component: () => import("@/page/track/seller"),
                    meta: {
                        authorize: true,
                        title: "直销员看板",
                    }
                }
            ]
        },
        {
            path: "/track/v2/index",
            name: "trackIndex",
            component: () => import("@/page/track/v2/index"),
            meta: {
                authorize: true,
                title: "A.0.史密斯",
            },
            children: [
                {
                    path: "/track/v2/developer",
                    name: "developer",
                    component: () => import("@/page/track/v2/developer"),
                    meta: {
                        authorize: true,
                        title: "开发者看板",
                    }
                },
                {
                    path: "/track/v2/management",
                    name: "management",
                    component: () => import("@/page/track/v2/management"),
                    meta: {
                        authorize: true,
                        title: "管理看板",
                    }
                },
                {
                    path: "/track/v2/seller",
                    name: "seller",
                    component: () => import("@/page/track/v2/seller"),
                    meta: {
                        authorize: true,
                        title: "直销员看板",
                    }
                },
                {
                    path: "/track/v2/report",
                    name: "report",
                    component: () => import("@/page/track/v2/report"),
                    meta: {
                        authorize: true,
                        title: "数据报表",
                    }
                }
            ]
        },
        {
            path: "/track/v3/index",
            name: "trackIndex",
            component: () => import("@/page/track/v3/index"),
            meta: {
                authorize: true,
                title: "A.0.史密斯",
            },
            children: [
                {
                    path: "/track/v3/developer",
                    name: "developer",
                    component: () => import("@/page/track/v3/developer"),
                    meta: {
                        authorize: true,
                        title: "开发者看板",
                    }
                },
                {
                    path: "/track/v3/management",
                    name: "management",
                    component: () => import("@/page/track/v3/management"),
                    meta: {
                        authorize: true,
                        title: "管理看板",
                    }
                },
                {
                    path: "/track/v3/seller",
                    name: "seller",
                    component: () => import("@/page/track/v3/seller"),
                    meta: {
                        authorize: true,
                        title: "直销员看板",
                    }
                },
                {
                    path: "/track/v3/report",
                    name: "report",
                    component: () => import("@/page/track/v3/report"),
                    meta: {
                        authorize: true,
                        title: "数据报表",
                    }
                }
            ]
        },
        {
            path: "/track/v4/index",
            name: "trackIndex",
            component: () => import("@/page/track/v4/index"),
            meta: {
                authorize: true,
                title: "A.0.史密斯",
            },
            children: [
                {
                    path: "/track/v4/developer",
                    name: "developer",
                    component: () => import("@/page/track/v4/developer"),
                    meta: {
                        authorize: true,
                        title: "开发者看板",
                    }
                },
                {
                    path: "/track/v4/management",
                    name: "management",
                    component: () => import("@/page/track/v4/management"),
                    meta: {
                        authorize: true,
                        title: "管理看板",
                    }
                },
                {
                    path: "/track/v4/seller",
                    name: "seller",
                    component: () => import("@/page/track/v4/seller"),
                    meta: {
                        authorize: true,
                        title: "直销员看板",
                    }
                },
                {
                    path: "/track/v4/report",
                    name: "report",
                    component: () => import("@/page/track/v4/report"),
                    meta: {
                        authorize: true,
                        title: "数据报表",
                    }
                }
            ]
        },
        {
            path: "/plan/pdf/index",
            name: "pdfPre",
            component: () => import("@/page/plan/pdf/index"),
            meta: {
                authorize: true,
                title: "A.O.史密斯",
            },
        },
        {
            path: "/member/v2/contract/error",
            name: "contracterror",
            component: () => import("@/page/member/v2/contract/error"),
            meta: {
                authorize: true,
                title: "A.O.史密斯",
            },
        },
        {
            path: "/model/preview/index",
            name: "modelpreview",
            component: () => import("@/page/model/preview/index"),
            meta: {
                authorize: false,
                title: "A.O.史密斯",
            },
        },
        {
            path: "/goods/pk/index", // pk
            name: "pk",
            component: () => import("@/page/goods/pk/index"),
            meta: {
                // authorize: true,
                title: "产品PK",
            },
        },
        {
            path: "/goods/pk/collect", // 收藏
            name: "collect",
            component: () => import("@/page/goods/pk/collect"),
            meta: {
                // authorize: true,
                title: "PK收藏",
            },
        },
        {
            path: "/cs/preview/preview", // preview
            name: "preview",
            component: () => import("@/page/cs/preview/preview"),
            meta: {
                authorize: true,
                title: "在线选型",
            },
        }
        // {
        //     path: "/demo/photograph",
        //     name: "photograph",
        //     component: () => import("@/page/demo/photograph"),
        //     meta: {
        //         authorize: false,
        //         title: "拍照demo",
        //     },
        // },
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return {x: 0, y: 0};
        }
    },

});

router.beforeEach((to, from, next) => {
    if (from.name != null) {
        if (to.path) {
            _hmt.push(['_trackPageview', to.fullPath]);
        }
    }
    //阿里ARMS
    useReporter.useARMS.use();

    // var agent = navigator.userAgent.toLowerCase(); // 浏览器类型
    // console.log(agent.match(/Chrome/i))
    if (to.meta.authorize) {
        $init(() => {
            if (to.meta.bLog) {
                let data = {
                    page_url: to.path,
                    history_id: store.state.nHistoryId,
                    browser_info: '',
                    click_name: '',
                    type: 0,
                }
                oInitData.singleAjaxData('report/log/log', data).then(res => {
                    let nHistoryId = res.data.data.result.history_id;
                    store.commit('setHistoryId', nHistoryId)
                })
            }
            //交付报告统计
            useReporter.useMemberLog.use(to)
            // 判断当前页面路径是不是用户卷宗页面，是则需要判断，当前用户是否是史密斯人员，是否为企业微信
            if (statistic.arrFileUrl.includes(to.path)) {
                oInitData.getData('dataview/index/userinfo', {}).then(res => {
                    let objData = res.data.data.result;// 判断环境

                    if (objData.is_admin == 1 && common.isWechat() == defalutData.weChat.wxWork) {
                        next();
                    } else {
                        //本地调试不跳转/archives/error
                        if (process.env.VUE_APP_FLAG == "development") {
                            next();
                        } else {
                            next('/archives/error');
                        }
                    }
                    // next();
                })
            } else if (statistic.arrReportAuth.includes(to.path)) {
                console.log(to, from, '路由去向')
                if ((to.query.sampleroom == 2 || to.query.sampleroom == 3) && common.isWechat() != defalutData.weChat.wxWork) {
                    // 直销员分享链接在微信端跳转报错
                    next('/archives/error');
                } else {
                    next();
                }

            } else {
                next();
            }
        });
    } else if (to.meta.qyauthorize) {
        //企业微信登录之后init方法，同上面$init方法,区别在于oInitData.getToken()的回调处理
        // 获得默认数据
        storage.getDefaultData();
        // 获取url后面参数 如果是reload 清除本地数据
        if (common.getQueryString('wscinit') == 'reload2') {
            storage.setStorage('session_id', '');
            storage.setStorage('token', '');
            storage.setStorage('homeMenu', '');
            cookie.deleteAllCookie(); // 删除所有cookie
        }
        var is_login = storage.getStorage("is_login");
        if(!is_login){ //清空获取企业授权接口的session_id。让getToken重新调用init
            storage.removeStorage('session_id');
        }
        // 获取token
        oInitData.getToken().then(res => {
            if (store.state.initError) {
                //   console.log("严重：init接口错误！");
                return false;
            }
            /*// 判断用户登录*/
            if (res.is_login || to.path == '/project/v3/login/index') {
                next();
            } else {
                storage.setStorage('qy_login_callback', to.fullPath);
                next('/project/v3/login/index');
            }
        });
    } else {
        //交付报告统计
        useReporter.useMemberLog.use(to)
        next();
    }
});
router.afterEach((to, from, next) => {
    useReporter.useStatistics.use(to)
});

export default router;
